import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { Truck, Mail } from 'lucide-react';

const announcementKeys = [
  { key: 'announcement.freeShipping', icon: Truck },
  { key: 'announcement.reseller', icon: Mail },
];

export function AnnouncementBanner() {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % announcementKeys.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const current = announcementKeys[currentIndex];
  const Icon = current.icon;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-bronze text-ivory py-2.5 md:py-2 overflow-hidden shadow-sm">
      <div className="container mx-auto px-4">
        <AnimatePresence mode="wait">
          <motion.div
            key={current.key}
            initial={{ x: '100%', opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: '-100%', opacity: 0 }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
            className="flex items-center justify-center gap-2 text-center"
          >
            <Icon className="w-4 h-4 flex-shrink-0" />
            <span className="font-body text-xs md:text-sm leading-tight">{t(current.key)}</span>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}